import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import moment from 'moment'
import { fetchApi } from '../../services/fetch'
import { printLogs } from '../../utils'
import { endPoints } from '../../services/endPoints'

const tempBusinessId = 14851;

export const getBusinessesListAction = createAsyncThunk('businesses/getBusinesses',
    async (payload, { rejectWithValue }) => {
        let data = {
            "pageNumber": payload.pageNumber,
            "limitRowsPerPage": payload.limit,
        }
        const orgsData = {
            endPoint: endPoints.businessList,
            value: JSON.stringify(data),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getBusinessesListViaContactsAction = createAsyncThunk('businesses/getBusinessesListViaContacts',
    async (payload, { rejectWithValue }) => {
        let data = {
            "pageNumber": payload.pageNumber,
            "limitRowsPerPage": payload.limit,
        }
        const orgsData = {
            endPoint: endPoints.businessListContacts,
            value: JSON.stringify(data),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getBusinessTypesAction = createAsyncThunk('businesses/getBusinessTypes',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.businessTypes,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const addBusinessTypesAction = createAsyncThunk('businesses/addBusinessTypes',
    async (payload, { rejectWithValue }) => {

        const addData = {
            endPoint: endPoints.addBusinessType,
            type: "POST",
            value: JSON.stringify(payload),
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(addData);
        if (response.responseCode == 200 || response.responseCode == 201) return response?.json
        else { rejectWithValue(false); return false }
    })

export const editBusinessTypesAction = createAsyncThunk('businesses/editBusinessTypes',
    async (payload, { rejectWithValue }) => {
        printLogs("🚀 ~ payload:", payload)
        const constructedUrl = endPoints.editBusinessType + '/' + payload.codeBusinessTypeId
        printLogs("🚀 ~ constructedUrl:", constructedUrl)
        const updateData = {
            endPoint: constructedUrl,
            type: "PUT",
            value: JSON.stringify(payload),
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        printLogs("🚀 ~ updateData:", updateData)
        const response = await fetchApi(updateData);
        if (response.responseCode == 200 || response.responseCode === 204) return response?.json
        else { rejectWithValue(false); return false }
    })

export const deleteBusinessTypesAction = createAsyncThunk('businesses/deleteBusinessTypes',
    async (payload, { rejectWithValue }) => {

        const orgsData = {
            endPoint: endPoints.deleteBusinessTypeById + '/' + payload.codeBusinessTypeId,
            type: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200 || response.responseCode === 204) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getCommunityTypesAction = createAsyncThunk('businesses/getCommunityTypes',
    async (payload, { rejectWithValue }) => {

        const orgsData = {
            endPoint: endPoints.communityTypes,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const addCommunityTypesAction = createAsyncThunk('businesses/addCommunityTypes',
    async (payload, { rejectWithValue }) => {

        const addData = {
            endPoint: endPoints.addCommunityType,
            type: "POST",
            value: JSON.stringify(payload),
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(addData);
        if (response.responseCode == 200 || response.responseCode == 201) return response?.json
        else { rejectWithValue(false); return false }
    })

export const editCommunityTypesAction = createAsyncThunk('businesses/editCommunityTypes',
    async (payload, { rejectWithValue }) => {
        printLogs("🚀 ~ payload:", payload)
        const constructedUrl = endPoints.editCommunityType + '/' + payload.codeCommunityTypeId
        printLogs("🚀 ~ constructedUrl:", constructedUrl)
        const updateData = {
            endPoint: constructedUrl,
            type: "PUT",
            value: JSON.stringify(payload),
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        printLogs("🚀 ~ updateData:", updateData)
        const response = await fetchApi(updateData);
        if (response.responseCode == 200 || response.responseCode === 204) return response?.json
        else { rejectWithValue(false); return false }
    })

export const deleteCommunityTypesAction = createAsyncThunk('businesses/deleteCommunityTypes',
    async (payload, { rejectWithValue }) => {

        const orgsData = {
            endPoint: endPoints.deleteCommunityTypeById + '/' + payload.codeCommunityTypeId,
            type: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200 || response.responseCode === 204) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getMailingTypesAction = createAsyncThunk('businesses/getMailingTypes',
    async (payload, { rejectWithValue }) => {

        const orgsData = {
            endPoint: endPoints.mailingTypes,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const addMailingTypesAction = createAsyncThunk('businesses/addMailingTypes',
    async (payload, { rejectWithValue }) => {

        const addData = {
            endPoint: endPoints.addMailingTypes,
            type: "POST",
            value: JSON.stringify(payload),
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(addData);
        if (response.responseCode == 200 || response.responseCode == 201) return response?.json
        else { rejectWithValue(false); return false }
    })

export const editMailingTypesAction = createAsyncThunk('businesses/editMailingTypes',
    async (payload, { rejectWithValue }) => {
        printLogs("🚀 ~ payload:", payload)
        const constructedUrl = endPoints.editMailingTypes + '/' + payload.codeMailingListTypeId
        printLogs("🚀 ~ constructedUrl:", constructedUrl)
        const updateData = {
            endPoint: constructedUrl,
            type: "PUT",
            value: JSON.stringify(payload),
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        printLogs("🚀 ~ updateData:", updateData)
        const response = await fetchApi(updateData);
        if (response.responseCode == 200 || response.responseCode === 204) return response?.json
        else { rejectWithValue(false); return false }
    })

export const deleteMailingTypesAction = createAsyncThunk('businesses/deleteMailingTypes',
    async (payload, { rejectWithValue }) => {

        const orgsData = {
            endPoint: endPoints.deleteMailingTypeById + '/' + payload.codeMailingListTypeId,
            type: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200 || response.responseCode === 204) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getBusinessAddressesAction = createAsyncThunk('businesses/getBusinessAddresses',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.businessAddressesByBusinessId + '?businessId=' + payload,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getBusinessContactsAction = createAsyncThunk('businesses/getBusinessContacts',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.businessContactsByBusinessId + '?businessId=' + payload,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getBusinessContactSubscriptionsAction = createAsyncThunk('businesses/getBusinessContactSubs',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.subscriptionsByContactId + '?contactId=' + payload,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const addSubscriptionToBusinessContactAction = createAsyncThunk('businesses/addSubscriptionToBusinessContact',
    async (payload, { rejectWithValue }) => {
        const constructedUrl = endPoints.addSubscriptionToBusinessContact + '?businessContactId=' + payload.businessContactId + '&mailingListTypeId=' + payload.mailingListTypeId + '&createdBy=' + 'Mahesh'
        let data = {
            "businessContactId": payload.businessContactId,
            "mailingListTypeId": payload.mailingListTypeId,
            "createdBy": "Mahesh"
        }
        const orgsData = {
            endPoint: constructedUrl,
            value: JSON.stringify(data),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const removeSubscriptionFromBusinessContactAction = createAsyncThunk('businesses/removeSubscriptionFromBusinessContact',
    async (payload, { rejectWithValue }) => {
        const constructedUrl = endPoints.removeSubscriptionToBusinessContact + '?businessContactSubscriptionId=' + payload.businessContactSubscriptionId

        const orgsData = {
            endPoint: constructedUrl,
            type: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 204) return response?.json
        else { rejectWithValue(false); return false }
    })


export const updateBusinessDetailsAction = createAsyncThunk('businesses/updateBusinessDetails',
    async (payload, { rejectWithValue }) => {
        const constructedUrl = endPoints.businessDetails + '/' + payload.businessId
        const orgsData = {
            endPoint: constructedUrl,
            value: JSON.stringify(payload),
            type: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        printLogs("🚀 ~ orgsData:", orgsData)
        const response = await fetchApi(orgsData);
        console.log("🚀 ~ response:", response)
        if (response.responseCode == 200 && response.responseCode == 204) return response?.json
        else { rejectWithValue(false); return false }
    })

export const addBusinessAddressAction = createAsyncThunk('businesses/addBusinessAddress',
    async (payload, { rejectWithValue }) => {

        const orgsData = {
            endPoint: endPoints.addBusinessAddress,
            value: JSON.stringify(payload),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        printLogs("🚀 ~ orgsData:", orgsData)
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const updateBusinessAddressAction = createAsyncThunk('businesses/updateBusinessAddress',
    async (payload, { rejectWithValue }) => {

        const updateData = {
            endPoint: endPoints.updateBusinessAddress,
            value: JSON.stringify(payload),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }

        const response = await fetchApi(updateData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const delBusinessAddressAction = createAsyncThunk('businesses/delBusinessAddress',
    async (payload, { rejectWithValue }) => {

        const delData = {
            endPoint: endPoints.deleteBusinessAddress + '/' + payload.id,
            type: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }

        const response = await fetchApi(delData);
        if (response.responseCode == 204) return response?.json
        else { rejectWithValue(false); return false }
    })

export const addBusinessContactAction = createAsyncThunk('businesses/addBusinessContact',
    async (payload, { rejectWithValue }) => {

        const orgsData = {
            endPoint: endPoints.addBusinessContact,
            value: JSON.stringify(payload),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        printLogs("🚀 ~ orgsData:", orgsData)
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const updateBusinessContactAction = createAsyncThunk('businesses/updateBusinessContact',
    async (payload, { rejectWithValue }) => {

        const updateData = {
            endPoint: endPoints.updateContact,
            value: JSON.stringify(payload),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }

        const response = await fetchApi(updateData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const delBusinessContactAction = createAsyncThunk('businesses/delBusinessContact',
    async (payload, { rejectWithValue }) => {

        const delData = {
            endPoint: endPoints.deleteBusinessContact + '/' + payload.id,
            type: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }

        const response = await fetchApi(delData);
        if (response.responseCode == 204) return response?.json
        else { rejectWithValue(false); return false }
    })

export const searchAction = createAsyncThunk('businesses/search',
    async (payload, { rejectWithValue }) => {

        const searchData = {
            endPoint: endPoints.search + payload.searchText,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }

        const response = await fetchApi(searchData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })



export const searchStartsWithAction = createAsyncThunk('businesses/searchStartsWith',
    async (payload, { rejectWithValue }) => {

        const searchData = {
            endPoint: endPoints.searchStartsWith + payload.searchText,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }

        const response = await fetchApi(searchData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const searchEndsWithAction = createAsyncThunk('businesses/searchEndsWith',
    async (payload, { rejectWithValue }) => {

        const searchData = {
            endPoint: endPoints.searchEndsWith + payload.searchText,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }

        const response = await fetchApi(searchData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const exportAsPdfForMailingListAction = createAsyncThunk('businesses/exportAsPdfForMailingList',
    async (payload, { rejectWithValue }) => {

        const packet = {
            endPoint: endPoints.exportPdf + payload.CodeMailingListTypeId,
            type: "GET",
            responseType: 'blob', 
            headers: {
                "Content-Type": "application/json-patch+json",
               
            }
        }

        console.log('before calling fetch on export'); 
        const response = await fetchApi(packet);
        console.log(` after calling fetch api on export  ${response.responseCode} is it 200 ? ${response.responseCode == 200}`); 
        if (response.responseCode == 200) {
                console.group(`inside blobification`);
                console.log(" pre Blob response size check size in bytes:", response.json.size);
                console.log(" pre Blob response MIME check :", response.json.type);
              
                const blob = response.json;
                console.log(` got blob`);
                console.log("Blob size in bytes:", blob.size);
                console.log(" blob MIME type:", blob.type);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                console.log(`got url : ${url}`);
                link.setAttribute('download', 'export.pdf');

                console.log("515xyrs Blob size in bytes:", blob.size);
                console.log("Blobxyrs MIME type:", blob.type);

                document.body.appendChild(link);
                link.click();

                // Clean up
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);
                console.groupEnd();
             
            }

            

       
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    }) 
    

export const addBusinessAction = createAsyncThunk('businesses/addBusiness',
    async (payload, { rejectWithValue }) => {

        const orgsData = {
            endPoint: endPoints.addBusiness,
            value: JSON.stringify(payload),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        printLogs("🚀 ~ orgsData:", orgsData)
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200 || response.responseCode == 201) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getBusinessCountSubscriptionsAction = createAsyncThunk('businesses/getBusinessCountSubscriptions',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.countBusinessList,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getCommunityCountSubscriptionsAction = createAsyncThunk('businesses/getCommunityCountSubscriptions',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.countCommunityList,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getMailingCountSubscriptionsAction = createAsyncThunk('businesses/getMailingCountSubscriptions',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.countMailingList,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getEOCertifiedCountSubscriptionsAction = createAsyncThunk('businesses/getEOCertifiedCountSubscriptions',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.countEOCertifiedList,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getFloodGroupsCountSubscriptionsAction = createAsyncThunk('businesses/getFloodGroupsCountSubscriptions',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.countFloodGroupsList,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getMailingTypeBasedSearchAction = createAsyncThunk('businesses/getMailingTypeBasedSearch',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.searchViaMailingType + payload.mailingListTypeID,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getBusinessTypeBasedSearchAction = createAsyncThunk('businesses/getBusinessTypeBasedSearch',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.searchViaBusinessType + payload.businessTypeID,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })
export const getCommunityTypeBasedSearchAction = createAsyncThunk('businesses/getCommunityTypeBasedSearch',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.searchViaCommunityType + payload.communityTypeId,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })
export const getEOCertifiedSearchAction = createAsyncThunk('businesses/getEOCertifiedSearch',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.searchViaEOCertified,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })
export const getFloodGroupsBasedSearchAction = createAsyncThunk('businesses/getFloodGroupsBasedSearch',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.searchViaFloodGroups,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getBusinessesByMailingTypeIdAction = createAsyncThunk('businesses/getBusinessesByMailingTypeId',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.searchBusinessBySubscription + payload,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getGroupsByBusinessIdAction = createAsyncThunk('businesses/getGroupsByBusinessId',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.businessGroupsByBusinessId + payload,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const getBusinessByIdAction = createAsyncThunk('businesses/getBusinessById',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.businessById + payload,
            type: "GET",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const deactiveContactsAction = createAsyncThunk('businesses/deactiveContacts',
    async (payload, { rejectWithValue }) => {
        const userDetails = await localStorage.getItem('userDetails');
        const userEmail = JSON.parse(userDetails).mail;
        let data = {
            RequestingUser : userEmail,
            IsActive: payload.IsActive,
            IdsToToggle: payload.Ids
        }
        const orgsData = {
            endPoint: endPoints.deactivateSelectedContacts,
            value: JSON.stringify(data),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const purgeContactsAction = createAsyncThunk('businesses/purgeContacts',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.purgeSelectedContacts,
            value: JSON.stringify(payload),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })


export const deactiveAddressesAction = createAsyncThunk('businesses/deactiveAddresses',
    async (payload, { rejectWithValue }) => {
        const userDetails = await localStorage.getItem('userDetails');
        const userEmail = JSON.parse(userDetails).mail;
        let data = {
            RequestingUser: userEmail,
            IsActive: payload.IsActive,
            IdsToToggle: payload.Ids
        }
        const orgsData = {
            endPoint: endPoints.deactivateSelectedAddresses,
            value: JSON.stringify(data),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const purgeAddressesAction = createAsyncThunk('businesses/purgeAddresses',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.purgeSelectedAddresses,
            value: JSON.stringify(payload),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })
    
export const deactiveBusinessesAction = createAsyncThunk('businesses/deactiveBusinesses',
    async (payload, { rejectWithValue }) => {
        const userDetails = await localStorage.getItem('userDetails');
        const userEmail = JSON.parse(userDetails).mail;
        let data = {
            RequestingUser : userEmail,
            IsActive: payload.IsActive,
            IdsToToggle: payload.Ids
        }
        const orgsData = {
            endPoint: endPoints.deactivateBusinesses,
            value: JSON.stringify(data),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })

export const purgeBusinessesAction = createAsyncThunk('businesses/purgeBusinesses',
    async (payload, { rejectWithValue }) => {
        const orgsData = {
            endPoint: endPoints.purgeBusinesses,
            value: JSON.stringify(payload),
            type: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            }
        }
        const response = await fetchApi(orgsData);
        if (response.responseCode == 200) return response?.json
        else { rejectWithValue(false); return false }
    })